(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/client/api.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/client/api.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  logger
} = svs.numbergames.campaign._internal;
const {
  campaign
} = svs.numbergames.campaign.shared;
const {
  filterCampaignListByDrawNumber,
  filterCampaignsByDate
} = campaign;
const dataFetcherSingleton = new svs.numbergames.campaign._internal.ActiveCampaignsDataFetcher();
let campaignListDataFetcherSingleton;
let campaignDrawDataFetcherSingleton;
function getCampaignListDataFetcher() {
  if (!campaignListDataFetcherSingleton) {
    campaignListDataFetcherSingleton = new svs.numbergames.campaign._internal.CampaignListDataFetcher();
  }
  return campaignListDataFetcherSingleton;
}
function getCampaignDrawDataFetcher() {
  if (!campaignDrawDataFetcherSingleton) {
    campaignDrawDataFetcherSingleton = new svs.numbergames.campaign._internal.CampaignDrawDataFetcher();
  }
  return campaignDrawDataFetcherSingleton;
}
const getCampaignHeaderImage = async options => campaign.getCampaignHeaderImage(await dataFetcherSingleton.fetchData(options));
const hasActiveCampaign = async options => campaign.hasActiveCampaign(await dataFetcherSingleton.fetchData(options), options);
const calculateChances = async options => campaign.calculateChances(_objectSpread(_objectSpread({}, options), {}, {
  campaigns: await dataFetcherSingleton.fetchData(options)
}));
const calculateChancesSync = options => campaign.calculateChances(_objectSpread(_objectSpread({}, options), {}, {
  campaigns: dataFetcherSingleton.dataFromCache(options)
}));
const getCampaignPeriod = async options => campaign.getCampaignPeriod(await dataFetcherSingleton.fetchData(options), options);
const getCampaignName = async options => campaign.getCampaignName(await dataFetcherSingleton.fetchData(options), options);
const getWinPlan = async options => campaign.getWinPlan(await dataFetcherSingleton.fetchData(options));
const getCampaign = async _ref => {
  let {
    product,
    campaignDrawNumber,
    date
  } = _ref;
  if (campaignDrawNumber) {
    return await getCampaignDrawDataFetcher().fetchData({
      product,
      drawNumber: campaignDrawNumber
    });
  }
  if (date) {
    date = new Date(date);
    const year = dateFns.getYear(date);
    const month = dateFns.getMonth(date) + 1; 
    const campaigns = await getCampaignListDataFetcher().fetchData({
      product,
      year,
      month
    });
    const campaign = filterCampaignsByDate({
      campaigns,
      date
    });
    if (campaign) {
      return await getCampaignDrawDataFetcher().fetchData({
        product,
        drawNumber: campaign.drawNumber
      });
    }
    logger.debug("No campaign found using date: ".concat(date));
    return false;
  }
  const campaignArray = await dataFetcherSingleton.fetchData({
    product
  });
  return campaignArray === null || campaignArray === void 0 ? void 0 : campaignArray[0];
};
const drawStateIds = {
  DEFINED: 1,
  OPEN: 2,
  CLOSED: 4,
  FINALIZED: 20
};
const api = {
  getCampaignHeaderImage,
  hasActiveCampaign,
  calculateChances,
  calculateChancesSync,
  getCampaignPeriod,
  getCampaignName,
  getCampaign,
  getWinPlan,
  getCampaignListDataFetcher,
  getCampaignDrawDataFetcher,
  filterCampaignListByDrawNumber,
  filterCampaignsByDate,
  drawStateIds
};
Object.assign(svs.numbergames.campaign, api);

 })(window);